import { render, staticRenderFns } from "./IdentityUpdatePersonalDataPopup.vue?vue&type=template&id=59629625&"
import script from "./IdentityUpdatePersonalDataPopup.vue?vue&type=script&lang=js&"
export * from "./IdentityUpdatePersonalDataPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports